import { render, staticRenderFns } from "./infinitiv-vs-perfekt.vue?vue&type=template&id=a2099dce&scoped=true"
import script from "./infinitiv-vs-perfekt.vue?vue&type=script&lang=js"
export * from "./infinitiv-vs-perfekt.vue?vue&type=script&lang=js"
import style0 from "./infinitiv-vs-perfekt.vue?vue&type=style&index=0&id=a2099dce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2099dce",
  null
  
)

export default component.exports